<section class="flex flex-col items-center gap-6">
  <h1 class="text-4xl font-bold md:text-5xl">Contact Us</h1>
  <p class="text-xl">
    We're here to help. Choose the best way to reach out to our team based on
    your needs.
  </p>
</section>
